<!-- Renders a list of avatars, given a list of plans -->
<template>
	<div class="ml-3 flex">
		<PlanAvatar
			v-for="(plan, index) in plans"
			class="-ml-3"
			:index="plan.index"
			:filled="filled"
			:plan="plan.plan"
		/>
	</div>
</template>

<script setup lang="ts">
import PlanAvatar from './PlanAvatar.vue'
import { type IndexedPlan } from '@/classes/Plan'
import { type PropType } from 'vue'

defineProps({
	plans: Object as PropType<IndexedPlan[]>,
	filled: Boolean,
	large: Boolean,
})
</script>
